import checkStatus from "../../../helpers/checkStatus"
import cleanObject from "../../../helpers/cleanObject"

import * as http from "./http"

export function presentationAdd(presentation) {
  cleanObject(presentation)
  return dispatch => http.presentationAdd(presentation)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "PRESENTATION_CREATED"
      })
      return res
    })
}

export function presentationGetAll(eventId) {
  return dispatch => http.presentationGetAll(eventId)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "PRESENTATIONS_FETCHED",
        payload: {
          presentations: res.data
        }
      })
    })
    .catch(() => {
      // Long poll, ignore errors
      // Alert.error(err.message)
    })
}

export function presentationGetOne(_id) {
  return dispatch => http.presentationGetOne(_id)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "PRESENTATION_FETCHED",
        payload: {
          presentation: res.data
        }
      })
      return res
    })
}

export function presentationUpdate(_id, presentation) {
  cleanObject(presentation)
  return dispatch => http.presentationUpdate(_id, presentation)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "PRESENTATION_UPDATED"
      })
      return res
    })
}

export function presentationUpdatePrivacy(_id, presentation) {
  cleanObject(presentation)
  return dispatch => http.presentationUpdatePrivacy(_id, presentation)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "PRESENTATION_PRIVACY_UPDATED",
        payload: {
          presentation: res.data
        }
      })
      return res
    })
}

export function presentationAddFile(_id, file) {
  cleanObject(file)
  return dispatch => http.presentationAddFile(_id, file)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "PRESENTATION_FILE_ADDED",
        payload: {
          presentation: res.data
        }
      })
      return res
    })
}

export function presentationDeleteFile(_id, file) {
  cleanObject(file)
  return dispatch => http.presentationDeleteFile(_id, file)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "PRESENTATION_FILE_DELETED",
        payload: {
          presentation: res.data
        }
      })
      return res
    })
}

export function presentationDeleteVideo(_id) {
  return dispatch => http.presentationDeleteVideo(_id)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "PRESENTATION_FILE_DELETED",
        payload: {
          presentation: res.data
        }
      })
      return res
    })
}

export function presentationDelete(_id, eventId) {
  return dispatch => http.presentationDelete(_id)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch(presentationGetAll(eventId))
      return res
    })
}

export function addPresentationAsSpeaker(pptInfo, file) {
  cleanObject(file)
  return dispatch => http.addPresentationAsSpeaker(pptInfo, file)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "PRESENTATION_FILE_ADDED",
        payload: {
          presentation: res.data
        }
      })
    })
}

export function changePresentationPrivacyAsSpeaker(pptInfo, updateObject) {
  cleanObject(updateObject)
  return dispatch => http.changePresentationPrivacyAsSpeaker(pptInfo, updateObject)
    .then((res) => {
      return res.json()
    })
    .then(checkStatus)
    .then((res) => {
      dispatch({
        type: "PRESENTATION_PRIVACY_CHANGED",
        payload: {
          presentation: res.data
        }
      })
    })
}
